// Selectors
import { ApplicationState } from '../../store';


export const issueTypeSelector = (state: ApplicationState) => state.issueTypeState


